import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Formations from './pages/Formations';
import Avis from './pages/Avis';
import Contact from './pages/Contact';
import Code from './pages/Code';
import FormationsPermisB from './pages/FormationsPermisB';
import AAC from './pages/AAC';
import ConduiteSupervisee from './pages/ConduiteSupervisee';
import InfosUtiles from './pages/InfosUtiles';
import QuestionnaireSatisfaction from './pages/QuestionnaireSatisfaction';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/formations" element={<Formations />} />
            <Route path="/formations-permis-b" element={<FormationsPermisB />} />
            <Route path="/aac" element={<AAC />} />
            <Route path="/conduite-supervisee" element={<ConduiteSupervisee />} />
            <Route path="/avis" element={<Avis />} />
            <Route path="/infos-utiles" element={<InfosUtiles />} />
            <Route path="/questionnaire-satisfaction" element={<QuestionnaireSatisfaction />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/code" element={<Code />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
